document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
});

/* Revela elementos .mt-reveal al entrar en pantalla, en cascada dentro de cada contenedor */
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = el.dataset.mtDelay || 0;
        setTimeout(function () { el.classList.add('mt-visible'); }, Number(delay));
        observer.unobserve(el);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

/* Cuenta hasta el numero objetivo cuando el elemento entra en pantalla */
function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.dataset.mtContador) || 0;
        var duracion = 1400;
        var inicio = null;

        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = target * progreso;
          el.textContent = target % 1 === 0 ? Math.floor(valor) : valor.toFixed(1);
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = target % 1 === 0 ? target : target.toFixed(1);
        }
        requestAnimationFrame(paso);
        observer.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );

  els.forEach(function (el) { observer.observe(el); });
}

/* Cambia la imagen principal de la galeria de producto al pulsar una miniatura */
function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;

  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');

  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.dataset.mtFull;
      var alt = mini.dataset.mtAlt || '';
      if (!full || !principal) return;
      principal.src = full;
      principal.alt = alt;
      miniaturas.forEach(function (m) { m.classList.remove('is-active'); });
      mini.classList.add('is-active');
    });
  });
}

/* Selector de variantes: actualiza precio, id oculto del formulario y estado agotado */
function initVariantesProducto() {
  var wrap = document.querySelector('[data-mt-producto]');
  if (!wrap) return;

  var dataEl = wrap.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var pills = wrap.querySelectorAll('[data-mt-opcion-valor]');
  var inputId = wrap.querySelector('[data-mt-input-id]');
  var precioActual = wrap.querySelector('[data-mt-precio-actual]');
  var precioAnterior = wrap.querySelector('[data-mt-precio-anterior]');
  var botonAgregar = wrap.querySelector('[data-mt-agregar]');
  var estadoAgotado = wrap.querySelector('[data-mt-agotado]');

  function opcionesSeleccionadas() {
    var seleccion = [];
    var grupos = wrap.querySelectorAll('[data-mt-opcion-grupo]');
    grupos.forEach(function (grupo) {
      var activo = grupo.querySelector('.is-active');
      seleccion.push(activo ? activo.dataset.mtOpcionValor : null);
    });
    return seleccion;
  }

  function formatoMoneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
    });
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });

    if (!variante) return;

    if (inputId) inputId.value = variante.id;
    if (precioActual) {
      try { precioActual.textContent = formatoMoneda(variante.price); } catch (e) {}
    }
    if (precioAnterior) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnterior.textContent = formatoMoneda(variante.compare_at_price);
        precioAnterior.style.display = '';
      } else {
        precioAnterior.style.display = 'none';
      }
    }

    if (botonAgregar) {
      if (variante.available) {
        botonAgregar.disabled = false;
        botonAgregar.dataset.mtOriginal = botonAgregar.dataset.mtOriginal || botonAgregar.textContent;
        botonAgregar.textContent = botonAgregar.dataset.mtOriginal;
        if (estadoAgotado) estadoAgotado.style.display = 'none';
      } else {
        botonAgregar.disabled = true;
        if (estadoAgotado) estadoAgotado.style.display = '';
      }
    }
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.hasAttribute('disabled')) return;
      var grupo = pill.closest('[data-mt-opcion-grupo]');
      grupo.querySelectorAll('[data-mt-opcion-valor]').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      actualizar();
    });
  });

  actualizar();
}

/* Botones +/- del selector de cantidad en la ficha de producto */
function initCantidadProducto() {
  var caja = document.querySelector('[data-mt-cantidad-caja]');
  if (!caja) return;
  var input = caja.querySelector('input');
  var menos = caja.querySelector('[data-mt-menos]');
  var mas = caja.querySelector('[data-mt-mas]');
  if (!input || !menos || !mas) return;

  menos.addEventListener('click', function () {
    var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    input.value = val;
  });
  mas.addEventListener('click', function () {
    var val = (parseInt(input.value, 10) || 1) + 1;
    input.value = val;
  });
}
